"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePasswordAsync = exports.validatePassword = exports.validateEmailAsync = exports.validateEmail = exports.validateIDCardAsync = exports.validateIDCard = exports.validateBankCardAsync = exports.validateBankCard = exports.validateNameAsync = exports.validateName = exports.validateNumAsync = exports.validateNum = exports.validateEnChStrAsync = exports.validateEnChStr = exports.validateStrLenAsync = exports.validateStrLen = exports.validatePhoneAsync = exports.validatePhone = exports.validateNonEmptyAsync = exports.validateNonEmpty = void 0;
const hub_utilities_is_1 = require("@yw/hub.utilities.is");
function validateNonEmpty(value) {
    return !(0, hub_utilities_is_1.isEmpty)(value);
}
exports.validateNonEmpty = validateNonEmpty;
function validateNonEmptyAsync(value, message) {
    return new Promise((resolve, reject) => {
        if (validateNonEmpty(value))
            resolve(true);
        else
            reject({ message: message !== null && message !== void 0 ? message : 'validate failed' });
    });
}
exports.validateNonEmptyAsync = validateNonEmptyAsync;
function validatePhone(phone) {
    return (0, hub_utilities_is_1.isMobile)(phone);
}
exports.validatePhone = validatePhone;
function validatePhoneAsync(phone, message) {
    return new Promise((resolve, reject) => {
        if (validatePhone(phone))
            resolve(true);
        else
            reject({ message: message !== null && message !== void 0 ? message : 'validate failed' });
    });
}
exports.validatePhoneAsync = validatePhoneAsync;
function validateStrLen(str, min = 1, max = -1) {
    if (max !== -1 && max < min) {
        throw new RangeError('max must not less then min');
    }
    if (max === -1)
        return str.length >= min;
    return str.length >= min && str.length <= max;
}
exports.validateStrLen = validateStrLen;
function validateStrLenAsync(str, min = 1, max = -1, message) {
    return new Promise((resolve, reject) => {
        if (validateStrLen(str, min, max))
            resolve(true);
        else
            reject({ message: message !== null && message !== void 0 ? message : 'validate failed' });
    });
}
exports.validateStrLenAsync = validateStrLenAsync;
function validateEnChStr(str) {
    return /^[a-zA-Z\u4e00-\u9fa5]+$/.test(str);
}
exports.validateEnChStr = validateEnChStr;
function validateEnChStrAsync(str, message) {
    return new Promise((resolve, reject) => {
        if (validateEnChStr(str))
            resolve(true);
        else
            reject({ message: message !== null && message !== void 0 ? message : 'validate failed' });
    });
}
exports.validateEnChStrAsync = validateEnChStrAsync;
function validateNum(num) {
    const numStr = String(num);
    return /^[0-9]+$/.test(numStr);
}
exports.validateNum = validateNum;
function validateNumAsync(num, message) {
    return new Promise((resolve, reject) => {
        if (validateNum(num))
            resolve(true);
        else
            reject({ message: message !== null && message !== void 0 ? message : 'validate failed' });
    });
}
exports.validateNumAsync = validateNumAsync;
function validateName(name) {
    return /^[\u4E00-\u9FA5]+(·[\u4E00-\u9FA5]+)*$/.test(name);
}
exports.validateName = validateName;
function validateNameAsync(name, message) {
    return new Promise((resolve, reject) => {
        if (validateName(name))
            resolve(true);
        else
            reject({ message: message !== null && message !== void 0 ? message : 'validate failed' });
    });
}
exports.validateNameAsync = validateNameAsync;
function validateBankCard(bankCard) {
    const bc = bankCard.replace(/\s/g, '');
    return (0, hub_utilities_is_1.isBankCard)(bc);
}
exports.validateBankCard = validateBankCard;
function validateBankCardAsync(bankCard, message) {
    return new Promise((resolve, reject) => {
        if (validateBankCard(bankCard))
            resolve(true);
        else
            reject({ message: message !== null && message !== void 0 ? message : 'validate failed' });
    });
}
exports.validateBankCardAsync = validateBankCardAsync;
function validateIDCard(idCard) {
    return (0, hub_utilities_is_1.isIDCard)(idCard);
}
exports.validateIDCard = validateIDCard;
function validateIDCardAsync(idCard, message) {
    return new Promise((resolve, reject) => {
        if (validateIDCard(idCard))
            resolve(true);
        else
            reject({ message: message !== null && message !== void 0 ? message : 'validate failed' });
    });
}
exports.validateIDCardAsync = validateIDCardAsync;
function validateEmail(email) {
    return (0, hub_utilities_is_1.isEmail)(email);
}
exports.validateEmail = validateEmail;
function validateEmailAsync(email, message) {
    return new Promise((resolve, reject) => {
        if (validateEmail(email))
            resolve(true);
        else
            reject({ message: message !== null && message !== void 0 ? message : 'validate failed' });
    });
}
exports.validateEmailAsync = validateEmailAsync;
function validatePassword(password, minLength = 8, maxLength = 16) {
    const regex = new RegExp(`^(?=.*[a-zA-Z])(?=.*\\d)[\\da-zA-Z]{${minLength},${maxLength}}$`);
    return regex.test(password);
}
exports.validatePassword = validatePassword;
function validatePasswordAsync(password, minLength = 8, maxLength = 16, message) {
    return new Promise((resolve, reject) => {
        if (validatePassword(password, minLength, maxLength))
            resolve(true);
        else
            reject({ message: message !== null && message !== void 0 ? message : 'validate failed' });
    });
}
exports.validatePasswordAsync = validatePasswordAsync;
//# sourceMappingURL=validate.js.map